import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  faDownload,
  faEye,
  faListAlt,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FileUpload } from "../../../model/domain/File";
import { AuthService } from "../../../services/auth.service";
import { DialogService } from "../../../services/dialog.service";
import { DownloadService } from "../../../services/download.service";
import { FileService } from "../../../services/file.service";
import { LoaderService } from "../../../services/loader.service";
import { SnackbarService } from "../../../services/snackbar.service";
import { Roles } from "../../auth/auth.role";

@Component({
  selector: "app-file-list-table",
  templateUrl: "./file-list-table.component.html",
  styleUrls: ["./file-list-table.component.scss"],
})
export class FileListTableComponent implements OnInit {
  @Input() ticketId: any = 0;
  @Input() tempId: any = 0;
  @Input() structuredSubTypeFile: number = 0;
  @Input() canEdit: boolean = false;
  @Output() emitterAllFileList: EventEmitter<any> = new EventEmitter();

  fileList: FileUpload[] = [];
  faDownload = faDownload;
  faEye = faEye;
  faTrash = faTrash;
  faListAlt = faListAlt;
  faPlus = faPlus;

  roles: number[] = [];
  canDelete: any[] = [];

  constructor(
    private fileService: FileService,
    private downloadService: DownloadService,
    private loaderService: LoaderService,
    private snackBarService: SnackbarService,
    private dialogService: DialogService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loadFiles();
  }

  modelInit() {
    this.loadFiles();
  }

  loadFiles() {
    this.fileService
      .getAllFilesAttachment(
        this.tempId,
        this.ticketId,
        null,
        null,
        this.structuredSubTypeFile
      )
      .subscribe((result) => {
        if (result) {
          this.fileList = result;

          if(this.canEdit) {
            result.forEach((file) => {
              this.setIsRemovable(file.id, file.creationUser);
            });
          }
        } else {
          this.fileList = [];
        }
        this.emitterAllFileList.emit(this.fileList);
      });
  }

  setIsRemovable(id: number, createUser: string) {
    return this.canRemove(createUser).then((res) => {
      this.roles = res;
      const isGestor = this.authService.authToken.isAccountManager;
      const myRoles = this.roles.filter((z) => (isGestor ? z === 2 : z === 10));
      const isRemovable = this.authService.hasRoles(myRoles);

      this.canDelete.push({ id, isRemovable });
      return Promise.resolve(res);
    });
  }

  canDeleteFile(index: number): boolean {
    const canDelete = this.canDelete.find((x) => x.id === index);
    return canDelete && canDelete.isRemovable;
  }

  async canRemove(createUser: string) {
    return await this.authService.rolesByUsername(createUser).toPromise();
  }

  isValidFile(fileName: String): boolean {
    return (
      fileName.includes(".pdf") ||
      fileName.includes(".jpeg") ||
      fileName.includes(".png") ||
      fileName.includes(".jpg")
    );
  }

  canUploadTransfer() {
    const roles = [Roles.CreateTicketStructuredOperations];
    return this.authService.hasRoles(roles);
  }

  canApproveUpload() {
    const roles = [Roles.ApprovePendingApprovalAdm];
    return this.authService.hasRoles(roles);
  }

  delete(id: number) {
    this.fileService.delete(id).subscribe((res) => this.modelInit());
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        this.downloadService.downloadFile(data, name);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  openPdf(name: string) {
    var isPdf = name.includes(".pdf");

    const download = this.fileService.download(name);

    return download.subscribe((data: Blob) => {
      this.dialogService.modalFile(data, isPdf);
    });
  }

  ColumnsFile: string[] = ["name", "createDate", "createUser", "actions"];
}
